export default "__VITE_ASSET__04ca85cc__"